import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Line } from "@nivo/line";
import React, { useState } from "react";
import { MOBILE_WIDTH, TABLET_WIDTH } from "../../../../../utils/HelperStyles";
import StyledButton from "../../../../StyledButton";
import automationText from "./AutomationMagicText";
import { BuyButton, UpSaleContainer } from "./upsellStyles";

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
const Uppertitle = styled.div`
  font: normal normal normal 30px "Georgia";
  margin-bottom: 10px;

  @media (max-width: ${TABLET_WIDTH}) {
    margin-top: 10px;
    font-size: 24px;
  }
`;
const Maintitle = styled.div`
  font: normal normal bold 49px "Georgia";
  color: rgb(1, 113, 0);
  text-align: center;

  padding-bottom: 15px;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 29px;
  }
`;
const Subtitle = styled.div`
  font: normal normal bold 24px "Georgia";
  text-align: center;

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 14px;
  }
`;

const Middle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const MiddleTitle = styled.div`
  font: normal normal bold 40px "Georgia";
  color: rgb(1, 113, 0);
  text-align: center;

  padding-top: 10px;
  padding-bottom: 10px;
`;
const Middlecontent = styled.div`
  font: normal normal bold 38px "Georgia";
  text-align: center;
  > p {
    font: normal normal bold 18px "Georgia";

    @media (max-width: ${TABLET_WIDTH}) {
      font-size: 16px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  font: normal normal normal 16px "Georgia";

  > p {
    text-align: left;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    font-size: 14px;
  }
`;

const BottomNote = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Note = styled.div``;

const ActionDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;
  border: 5px dashed #ff644e;
  padding: 40px;
  width: 80%;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const ActionTitle = styled.div`
  font: normal normal bold 23px "Georgia";
  padding-bottom: 15px;
`;
const ActionContent = styled.div`
  font-size: 16px;
`;

const NotAdd = styled.div`
  text-align: center;
  cursor: pointer;
  color: #1f1e1e;
`;

const LineItem = styled.li<{ bold?: boolean }>`
  margin-left: -25px;
  margin-top: 10px;
  margin-bottom: 10px;
  ${(props) => (props.bold ? "font-weight: bold;" : "")}
`;

interface Props {
  onBuy: () => void;
  onNoThanks: () => void;
  isModal?: boolean;
}

export default function AutomationMagic(props: Props): JSX.Element {
  const { onBuy, onNoThanks, isModal } = props;
  const [loading, setLoading] = useState(false);
  // const isMobile = useMobile();

  return (
    <UpSaleContainer isModal={isModal}>
      <Header>
        {/* <Uppertitle>How To Create Your Own Subscription Business</Uppertitle> */}
        <Maintitle>
          Behold A One Time Offer <br />
          For New BerserkerMail Clients <br />
          That Vanishes The Second <br />
          You Close This Window:
        </Maintitle>
      </Header>
      <Middle>
        <Subtitle>
          How to get former Navy Nuclear engineer-turned world class email &
          marketing automation specialist Troy Broussard’s wildly popular
          “Automation Magic” video course delivered right to your phone, and for
          a mere…
        </Subtitle>

        {/* <MiddleTitle>“Subscription Biz”</MiddleTitle> */}
        <Middlecontent style={{ marginTop: 15, marginBottom: 15 }}>
          $71
        </Middlecontent>
      </Middle>
      <Content>
        <p>Usually this puppy retails at $471.</p>
        <p>
          And it is designed to help both “tech cavemen” and experienced pros
          already making millions per year almost effortlessly (behind the
          scenes) close more new customers & clients... prevent churn & or
          having to chase fees... and automate dozens of other nagging business,
          prospecting, & marketing tasks — all explained in a way even someone
          who can barely work a toaster can understand.
        </p>
        If you do not want it, no worries, just scroll down and complete your
        order.
        <p>
          But if you are intrigued, here is a small glimpse at what’s inside:
        </p>
        <ul style={{ margin: 0 }}>
          {automationText.split("\n\n").map((item, index) => {
            return <LineItem bold={index % 2 === 0}>{item}</LineItem>;
          })}
        </ul>
        <p>
          Again this video course — delivered to your phone — normally retails
          for $471.
        </p>
        But if you add it to your order before leaving this page, it’s yours for
        a mere $71.
      </Content>
      {/* <BottomNote>
        <Note>
          <b>
            <u>
              And yes, you can adapt the info to your new SocialLair platform to
              turn it into a subscription business unto itself
              <p style={{ fontSize: "24px", fontWeight: 800 }}>NOTE:</p>
              There are no refunds on Subscription Biz, and all sales are final.
              If you are at-all unsure you want it, please pass up on it and
              continue with your order:
            </u>
          </b>
        </Note>
        <p>Add it to your order below or continue to complete your checkout…</p>
      </BottomNote> */}
      <ActionDiv>
        {/* <ActionTitle>Yeah! I'm ready Troy and Ben!</ActionTitle> */}
        <ActionContent>
          I understand that there are no refunds and that all sales are final. I
          also understand that this training is only available within the mobile
          app.
        </ActionContent>
        <BuyButton
          onClick={() => {
            setLoading(true);
            onBuy();
          }}
          isLoading={loading}
        >
          Buy Now!
        </BuyButton>
        By clicking above, a total of $71 will be charged from your card.
      </ActionDiv>
      <NotAdd onClick={onNoThanks}>
        <b>
          <u>No thanks, please do not add this offer to my purchase.</u>
        </b>
      </NotAdd>
    </UpSaleContainer>
  );
}
